import moment from 'moment-timezone';
import i18n from '../Utils/i18n';
export function getSafeTimezone(timeZone) {
  return timeZone && moment.tz(timeZone) ? timeZone : moment.tz.guess();
}

export function getSafeTimeWithZone(momentTime, timeZone) {
  const safeTimeZone = getSafeTimezone(timeZone);
  return moment(momentTime)
    .tz(safeTimeZone)
    .format(i18n.t('formatting.timeWithZone'));
}

export function buildMomentsBetweenDates(startDate, endDate) {
  let newDate = startDate.clone(),
    dates = [];

  while (newDate.isSameOrBefore(endDate)) {
    dates.push(newDate.clone());
    newDate.add(1, 'days');
  }
  return dates;
}

export function viewDateSorter(first, second) {
  return dateSorter(first.viewDate, second.viewDate);
}

export function dateSorter(first, second) {
  return moment(first).valueOf() > moment(second).valueOf() ? 1 : -1;
}



// WEBPACK FOOTER //
// ./src/Utils/MomentUtils.js